import React from "react"
import { Tooltip } from "../tooltip"

// =============================================================================
// Props
// =============================================================================

export type NavigationMenuProps = {
  /** `Navigation.Item` elements */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const menuStyles = [
  "flex flex-col flex-1 overflow-y-auto min-h-0",
  // this is needed because we have global styles for ul in application.css
  "list-none p-0"
].join(" ")

// =============================================================================
// Component
// =============================================================================

/**
 * Semantic list wrapper for `Navigation.Item` elements.
 * Renders a `<ul>` so screen readers announce the item count and users
 * can navigate the list with assistive technology shortcuts.
 *
 * @example
 * <Navigation.Menu>
 *   <Navigation.Item icon="dashboard" label="Dashboard" pathPrefix="/dashboard" render={<Link href="/dashboard" />} />
 *   <Navigation.Item icon="email" label="Broadcasts" pathPrefix="/broadcasts" render={<Link href="/broadcasts" />} />
 * </Navigation.Menu>
 */
export function NavigationMenu({ children }: NavigationMenuProps) {
  return (
    <Tooltip.Provider>
      <ul data-slot="navigation-menu" className={menuStyles}>
        {children}
      </ul>
    </Tooltip.Provider>
  )
}

NavigationMenu.displayName = "Navigation.Menu"
